import { Button } from '@/shared/components/ui/button';
import { Typography } from '@mui/material';
import { useAppDispatch } from 'features';
import { updateDownloadErrorFile } from 'features/Downloads';
import { useFileDownloader } from 'hooks/useFileDownloader';

import { type SelectedFile } from './interfaces';

interface RetryDownloadProps {
  file: SelectedFile;
}

const RetryDownload: React.FC<RetryDownloadProps> = ({ file }) => {
  const dispatch = useAppDispatch();
  const { downloadFile } = useFileDownloader();

  const statusMessages = {
    downloading: 'Si no inició la descarga de forma automática',
    error: 'Para intentar nuevamente',
  };

  if (file.status === 'downloaded') return null;

  const message = statusMessages[file.status];

  const handleRetry = () => {
    dispatch(updateDownloadErrorFile(file.id));
    void downloadFile(file);
  };

  return (
    <Typography fontSize={12}>
      {message},{' '}
      <Button
        size="sm"
        variant="link"
        onClick={handleRetry}
        className="$tw-p-0 $tw-text-xs $tw-normal-case $tw-text-foreground $tw-underline"
      >
        haz click aquí.
      </Button>
    </Typography>
  );
};

export default RetryDownload;
